export function LabChevronRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <path fill="currentColor" fillRule="evenodd" d="m10.743 7-4.29 5.362-.905-.724L9.258 7l-3.71-4.638.905-.724L10.743 7Z" clipRule="evenodd" />
    </svg>
  );
}
